//# sourceMappingURL=refresh_line.mjs.map
/// <reference types="./refresh_line.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function refresh_line() {
  return $svg.square(
    24,
    "<path d=\"M5.463 4.54776C7.27756 2.97542 9.59899 2.11141 12 2.11476C17.523 2.11476 22 6.59176 22 12.1148C22 14.2508 21.33 16.2308 20.19 17.8548L17 12.1148H20C20.0001 10.5464 19.5392 9.01256 18.6747 7.70401C17.8101 6.39546 16.5799 5.36991 15.1372 4.75488C13.6944 4.13984 12.1027 3.96246 10.56 4.24477C9.0172 4.52709 7.59145 5.25666 6.46 6.34276L5.463 4.54776ZM18.537 19.6818C16.7224 21.2541 14.401 22.1181 12 22.1148C6.477 22.1148 2 17.6378 2 12.1148C2 9.97876 2.67 7.99876 3.81 6.37476L7 12.1148H4C3.99987 13.6831 4.46075 15.217 5.32534 16.5255C6.18992 17.834 7.42007 18.8596 8.86282 19.4746C10.3056 20.0897 11.8973 20.2671 13.44 19.9847C14.9828 19.7024 16.4085 18.9729 17.54 17.8868L18.537 19.6818Z\" fill=\"currentColor\"/>",
  );
}
